import { render, staticRenderFns } from "./NgisMapModal.vue?vue&type=template&id=6f232e8c&"
import script from "./NgisMapModal.vue?vue&type=script&lang=js&"
export * from "./NgisMapModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports